import script from "./UnivationContactForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnivationContactForm.vue?vue&type=script&lang=ts&setup=true"

import "./UnivationContactForm.vue?vue&type=style&index=0&id=61c2a57e&lang=scss"

const __exports__ = script;

export default __exports__